module.exports = __webpack_public_path__ + "img/madl.7ade47b0.png";